import React from "react";
import useToggle from "../../../hooks/useToggle";
import GoToTop from "../../Helpers/GoToTop";
import SuccessModal from "../../Helpers/Modals/SuccessModal";
import Drawer from "../../Mobile/Drawer";
import FooterOne from "../../Partials/Footers/FooterOne";
import HeaderOne from "../../Partials/Headers/HeaderOne";
import MainContent from "../PlaceABidCom/MainContent";

function Purchase() {
  const [drawer, setDrawer] = useToggle(false);
  const [value, setValue] = useToggle(true);
  return (
    <>
      <Drawer drawer={drawer} action={setDrawer.toggle} />
      <HeaderOne className="shop-page-header" action={setDrawer.toggle} />
      <MainContent modalAction={setValue.toggle}>
        <SuccessModal
          action={setValue.toggle}
          value={value}
          className="purchases_uccessfull"
        />
      </MainContent>
      <FooterOne />
      <GoToTop />
    </>
  );
}

export default Purchase;
